module.exports = __webpack_public_path__ + "img/close-guide.a19f323e.svg";